import ExlibrisText from './assets/brand/exlibris_text.png';
import { FaHome, FaTable, FaChartBar, FaBook, FaChartLine } from 'react-icons/fa';
import AgDALogo from './assets/brand/agda_logo.png';
import { Card } from 'antd';
import { Collapse, Typography, Divider } from "antd";
import './style.css'


function Sidebar({clearNotifications, setActiveComponent, checkDbSelected, activeComponent, loadingFilterObjects,etlNotification }) {
    const { Panel } = Collapse;
    const { Text } = Typography;
    return (<div className='sidebar'>
                            <div className="d-flex justify-content-between align-items-center px-3 mt-4 mb-1">
                                <img
                                    src={ExlibrisText}
                                    alt="Exlibris"
                                    className='exlibris-title'
                                    onClick={() => {
                                        clearNotifications();
                                        setActiveComponent('home');
                                    }}
                                />
                            </div>
                            <hr />
                            <ul className="nav nav-pills flex-column mb-auto gap-1">
                                <li className="nav-item">
                                    <button disabled={loadingFilterObjects} className={`nav-link sidebar-nav d-flex align-items-center 
                                    ${activeComponent === 'home' ? 'active' : ''}`}
                                        onClick={() => {
                                            clearNotifications();
                                            setActiveComponent('home');
                                        }}>
                                        <FaHome className="mr-2" style={{ fontSize: "1.5rem" }} />
                                        <span style={{ marginLeft: "0.5rem" }}>Home</span>
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button disabled={loadingFilterObjects} className={`nav-link sidebar-nav d-flex align-items-center 
                                ${activeComponent === 'rawData' || activeComponent === 'rawDataSelectedLines' ? 'active' : ''}`}
                                        onClick={() => {
                                            clearNotifications();
                                            checkDbSelected();
                                            setActiveComponent('rawData');
                                        }}>
                                        <FaTable className="mr-2" style={{ fontSize: "1.5rem" }} />
                                        <span style={{ marginLeft: "0.5rem" }}>Raw Data</span>
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button disabled={loadingFilterObjects} className={`nav-link sidebar-nav d-flex align-items-center 
                                ${activeComponent === 'meansData' || activeComponent === 'meansDataSelectedLines' ? 'active' : ''}`}
                                        onClick={() => {
                                            clearNotifications();
                                            checkDbSelected();
                                            setActiveComponent('meansData');
                                        }}>
                                        <FaChartBar className="mr-2" style={{ fontSize: "1.5rem" }} />
                                        <span style={{ marginLeft: "0.5rem" }}>Means Data</span>
                                    </button>
                                </li>
                                <li className="nav-item link-pointer">
                                    <button disabled={loadingFilterObjects} className={`nav-link sidebar-nav d-flex align-items-center 
                                ${activeComponent === 'experiments' ? 'active' : ''}`}
                                        onClick={() => {
                                            clearNotifications();
                                            checkDbSelected();
                                            setActiveComponent('experiments');
                                        }}>
                                        <FaBook className="mr-2" style={{ fontSize: "1.5rem" }} />
                                        <span style={{ marginLeft: "0.5rem" }}>Experiments</span>
                                    </button>
                                </li>
                                <li className="nav-item link-pointer">
                                    <button disabled={loadingFilterObjects} className={`nav-link sidebar-nav d-flex align-items-center
                                ${activeComponent === 'blups' ? 'active' : ''}`}
                                        onClick={() => {
                                            clearNotifications();
                                            checkDbSelected();
                                            setActiveComponent('blups');
                                        }}>
                                        <FaChartLine className="mr-2" style={{ fontSize: "1.5rem" }} />
                                        <span style={{ marginLeft: "0.5rem" }}>BLUPs Analysis</span>
                                    </button>
                                </li>
                                {/* Removed Sync button for v3 */}
                                {/*<li className="nav-item link-pointer">
                            <button className={`nav-link d-flex align-items-center
                                ${activeComponent === 'sync' ? 'active' : ''}`} 
                                onClick={()=>{                     
                                    setActiveComponent('sync');
                                    }}>
                                <FaSyncAlt className="mr-2" style={{fontSize: "1.5rem"}} />
                                <span style={{marginLeft: "0.5rem"}}>Sync</span>
                            </button>
                                </li>    */}
    
                            </ul>
                            <hr />
                           <Collapse
                            accordion
                            bordered={false}
                            style={{
                                background: "#fff",
                                borderRadius: 6,
                                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                            }}
                            expandIconPosition="end"
                            >
                                    {/* ETL Notification */}
                                    <Collapse.Panel
                                        header={
                                        <span style={{ color: "#000000a5", fontWeight: 600, fontSize: "14px" }}>
                                            ETL Notification
                                        </span>
                                        }
                                        key="etl"
                                        style={{ marginBottom: 4 }}
                                    >
                                        <Card
                                        bordered={false}
                                        bodyStyle={{ padding: "4px 8px" }}
                                        style={{
                                            background: "#fafafa",
                                            borderRadius: 6,
                                            boxShadow: "inset 0 0 2px rgba(0,0,0,0.05)",
                                        }}
                                        >
                                        <p style={{ fontWeight: 600, margin: "2px 0", textDecoration:'underline'}}>Last Pipeline Runtime </p>
                                        <p style={{ margin: "0 0 4px 0" }}>
                                            {etlNotification.lastLocalDate}
                                            <br />
                                            {etlNotification.lastLocalTime}
                                        </p>
                                        <p style={{ fontWeight: 600, margin: "2px 0",textDecoration:'underline' }}>Next Pipeline Runtime </p>
                                        <p style={{ margin: 0 }}>
                                            {etlNotification.nextLocalDate}
                                            <br />
                                            {etlNotification.nextLocalTime}
                                        </p>
                                        </Card>
                                    </Collapse.Panel>

                                    {/* Button Specifications */}
                                    <Collapse.Panel
                                        header={
                                        <span style={{ color: "#000000a5", fontWeight: 600, fontSize: "14px" }}>
                                            Button Specifications
                                        </span>
                                        }
                                        key="button"
                                    >
                                        <Card
                                        bordered={false}
                                        bodyStyle={{ padding: "4px 8px" }}
                                        style={{
                                            background: "#fafafa",
                                            borderRadius: 6,
                                            boxShadow: "inset 0 0 2px rgba(0,0,0,0.05)",
                                        }}
                                        >
                                        <p style={{ fontWeight: 600, margin: "2px 0", textDecoration: "underline"}}>Select Year Range</p>
                                        <p>Just Put The Start and End Year of Your Choice</p>
                                      
                                        <p style={{ fontWeight: 600, margin: "2px 0", textDecoration: "underline" }}>Select All or Select Similar</p>
                                       <p>All: Select All the Experiments</p>
                                       <p>Similar: Select Only a Subset of Matched Strings</p>
                                        </Card>
                                    </Collapse.Panel>
                            </Collapse>
                            {/* <Card >
                                <h5 style={{color:'red'}}>ETL Notification</h5>
                                <hr/>
                                <p style={{fontWeight:600}}>Last Pipeline Runtime :</p> <p>{etlNotification.lastLocalDate}<br></br>{etlNotification.lastLocalTime} </p>
                                <p style={{fontWeight:600}}>Next Pipeline Runtime:</p> <p>{etlNotification.nextLocalDate}<br></br>{etlNotification.nextLocalTime} </p>
                            </Card>
                          
                            
                            <Card >
                                <h5 style={{color:'red'}}>Button Specifications</h5>
                                <hr/>
                                <p style={{fontWeight:600}}>Last Pipeline Runtime :</p> <p>{etlNotification.lastLocalDate}<br></br>{etlNotification.lastLocalTime} </p>
                                <p style={{fontWeight:600}}>Next Pipeline Runtime:</p> <p>{etlNotification.nextLocalDate}<br></br>{etlNotification.nextLocalTime} </p>
                            </Card> */}
                            <div className="one">
                                <div className="site-link">
                                    <a
                                        rel="noreferrer"
                                        href="https://sites.google.com/ndsu.edu/plsc-bpdm/home?authuser=0"
                                        target="_blank"
                                        className="d-flex align-items-center"
                                    >
                                        <img
                                            className='brand-logo'
                                            src={AgDALogo}
                                            alt="NDSU Agricultural Data Analytics"
                                        />
                                    </a>
                                </div>
    
                            </div>
                        </div>
    )
}

export default Sidebar;